import { render } from "./CountryData.vue?vue&type=template&id=560646e4&scoped=true"
import script from "./CountryData.vue?vue&type=script&lang=js"
export * from "./CountryData.vue?vue&type=script&lang=js"

import "./CountryData.vue?vue&type=style&index=0&id=560646e4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560646e4"]])

export default __exports__